import request from "./../utils/request";

export function getConversationReports(perPage = 100, page = 1, startDate = null, endDate = null, userIds = []) {
    const qs = {
        perPage: perPage,
        pageCount: page,
        dateBegin: startDate,
        dateEnd: endDate,
        userIds: userIds.join(","),
    };

    Object.keys(qs).forEach((key) => {
        if (!qs[key]) {
            delete qs[key];
        }
    });

    return request.get("/reports/conversation", {
        params: qs,
    });
}

export function getAggregationReports(perPage = 100, page = 1, startDate = null, endDate = null, userIds = []) {
    const qs = {
        perPage: perPage,
        pageCount: page,
        dateBegin: startDate,
        dateEnd: endDate,
        userIds: userIds.join(","),
    };

    Object.keys(qs).forEach((key) => {
        if (!qs[key]) {
            delete qs[key];
        }
    });

    return request.get("/reports/aggregate-conversation", {
        params: qs,
    });
}

export function getDetailedReports(perPage = 100, page = 1, startDate = null, endDate = null, userIds = []) {
    const qs = {
        perPage: perPage,
        pageCount: page,
        dateBegin: startDate,
        dateEnd: endDate,
        userIds: userIds.join(","),
    };

    Object.keys(qs).forEach((key) => {
        if (!qs[key]) {
            delete qs[key];
        }
    });

    return request.get("/reports/detail-conversation", {
        params: qs,
    });
}

export function getPointReports(perPage = 100, page = 1, startDate = null, endDate = null, userIds = []) {
    const qs = {
        perPage: perPage,
        pageCount: page,
        dateBegin: startDate,
        dateEnd: endDate,
        userIds: userIds.join(","),
    };

    Object.keys(qs).forEach((key) => {
        if (!qs[key]) {
            delete qs[key];
        }
    });

    return request.get("/reports/point-conversation", {
        params: qs,
    });
}

export class generalReport {}
